export const initialRem = () => {
    const w: number = 375
    const initFontSize = (w: number) => {
        const c = document.documentElement.clientWidth
        const h = document.documentElement.clientHeight
        const fontSize = document.documentElement.style.fontSize
        let val: string
        let cw: number
        if (c / 2 > w) {
            cw = w
        } else {
            cw = c / 2
        }
        if (c > h) {
            val = (cw / w) * 100 + 'px'
        } else {
            val = 50 + 'px'
        }
        if (!fontSize || fontSize === '0px') val = 51.9718 + 'px'
        document.documentElement.style.fontSize = val
    }
    initFontSize(w)
    window.addEventListener('resize', () => initFontSize(w))
}
